/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Share_Common_Area_NumeratorInputs */

const cs_sreality_attr_share_common_area_numerator = /** @type {(inputs: Sreality_Attr_Share_Common_Area_NumeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíl na společných částech — čitatel`)
};

const en_sreality_attr_share_common_area_numerator = /** @type {(inputs: Sreality_Attr_Share_Common_Area_NumeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share of common areas — numerator`)
};

/**
* | output |
* | --- |
* | "Share of common areas — numerator" |
*
* @param {Sreality_Attr_Share_Common_Area_NumeratorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_share_common_area_numerator = /** @type {((inputs?: Sreality_Attr_Share_Common_Area_NumeratorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Share_Common_Area_NumeratorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_share_common_area_numerator(inputs)
	return cs_sreality_attr_share_common_area_numerator(inputs)
});